'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var TextField = require('../../../core/TextField.js');
require('prop-types');
var AutocompleteHelper = require('../../../library/GoogleMap/AutocompleteHelper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GoogleAutocomplete = function GoogleAutocomplete(_ref) {
  var autoCompleteType = _ref.autoCompleteType,
      onAutoComplete = _ref.onAutoComplete,
      onTextFieldChange = _ref.onTextFieldChange,
      _onBlur = _ref.onBlur,
      _onFocus = _ref.onFocus,
      _onKeyDown = _ref.onKeyDown,
      allowedCountries = _ref.allowedCountries,
      restProps = objectWithoutProperties(_ref, ["autoCompleteType", "onAutoComplete", "onTextFieldChange", "onBlur", "onFocus", "onKeyDown", "allowedCountries"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      shrinkState = _useState2[0],
      setShrinkState = _useState2[1];

  var textRef = React.useRef(null);
  React.useEffect(function () {
    var options = {
      types: [autoCompleteType],
      fields: ['place_id', 'name', 'types']
    };
    var geoAutoComplete = new google.maps.places.Autocomplete(textRef.current, options);
    geoAutoComplete.addListener('place_changed', function () {
      var selected_place = geoAutoComplete.getPlace();
      selected_place.place_id && new google.maps.Geocoder().geocode({
        placeId: selected_place.place_id
      }, function (results) {
        placeSelected(_objectSpread({}, results[0], {
          name: selected_place.name.split(',')[0]
        }));
      });
    });
    allowedCountries && geoAutoComplete.setComponentRestrictions({
      country: allowedCountries
    });
    textRef.current.setAttribute('placeholder', '');
  }, []);
  React.useEffect(function () {
    if (restProps.value) {
      setShrinkState(!!restProps.value);
    }
  }, [restProps.value]);

  var placeSelected = function placeSelected(selectedPlace) {
    var callbackObject = AutocompleteHelper.parseGoogleAddress(selectedPlace);
    var request = {
      placeId: selectedPlace.place_id,
      fields: ['formatted_phone_number']
    };
    new google.maps.places.PlacesService(textRef.current).getDetails(request, function (place, status) {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        callbackObject['formatted_phone_number'] = place.formatted_phone_number;
      }
    });
    onAutoComplete && onAutoComplete(callbackObject);
  };

  return React__default["default"].createElement(TextField, _extends["default"]({}, restProps, {
    InputLabelProps: {
      shrink: shrinkState
    },
    fullWidth: true,
    inputRef: textRef,
    onKeyDown: function onKeyDown(event) {
      if (typeof _onKeyDown === 'function') {
        _onKeyDown(event);
      } else if (event.keyCode === 13) {
        event.preventDefault();
      }
    },
    onChange: function onChange(event) {
      return onTextFieldChange && onTextFieldChange(event);
    },
    onFocus: function onFocus(event) {
      setShrinkState(true);
      _onFocus && _onFocus(event);
    },
    onBlur: function onBlur() {
      if (textRef.current.value == "") {
        setShrinkState(false);
      }

      _onBlur && _onBlur();
    }
  }));
};

GoogleAutocomplete.defaultProps = {
  autoCompleteType: 'establishment'
};
var GoogleAutocomplete$1 = React.memo(GoogleAutocomplete);

module.exports = GoogleAutocomplete$1;
